import { TranslationKey } from '@src/types';

export interface ICategory {
  title: string;
  titleDisabled?: boolean;
  tooltip: string;
  headlineKey: TranslationKey;
  headlineMaxLen: number;
  paragraphKey: TranslationKey;
  paragraphMaxLen: number;
}

export const CategoriesData: ICategory[] = [
  {
    title: 'advanced-options.categories.text.essential.title',
    titleDisabled: true,
    tooltip: 'advanced-options.categories.text.essential.tooltip',
    headlineKey: TranslationKey.EssensialCategoryHeadline,
    headlineMaxLen: 30,
    paragraphKey: TranslationKey.EssensialCategoryParagraph,
    paragraphMaxLen: 300,
  },
  {
    title: 'advanced-options.categories.text.marketing.title',
    tooltip: 'advanced-options.categories.text.marketing.tooltip',
    headlineKey: TranslationKey.MarketingCategoryHeadline,
    headlineMaxLen: 30,
    paragraphKey: TranslationKey.MarketingCategoryParagraph,
    paragraphMaxLen: 300,
  },
  {
    title: 'advanced-options.categories.text.functional.title',
    tooltip: 'advanced-options.categories.text.functional.tooltip',
    headlineKey: TranslationKey.FunctionalCategoryHeadline,
    headlineMaxLen: 30,
    paragraphKey: TranslationKey.FunctionalCategoryParagraph,
    paragraphMaxLen: 300,
  },
  {
    title: 'advanced-options.categories.text.analytics.title',
    tooltip: 'advanced-options.categories.text.analytics.tooltip',
    headlineKey: TranslationKey.AnalyticsCategoryHeadline,
    headlineMaxLen: 30,
    paragraphKey: TranslationKey.AnalyticsCategoryParagraph,
    paragraphMaxLen: 300,
  },
];
